import {
    CoreSchemaTargetDto,
    DataAggregationFunction,
    ListUserDatasetDto,
    ResultSetSchemaTargetDto,
    SchemaFieldTargetDto,
    SchemaTargetDto,
    SchemaType,
    UserDatasetSchemaTargetDto
} from "../../services/api.services";

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace SchemaUtils {
  export function isCore(target: SchemaTargetDto | CoreSchemaTargetDto): target is CoreSchemaTargetDto {
    return target.type == SchemaType.Core;
  }

  export function isUserDataset(target: SchemaTargetDto | UserDatasetSchemaTargetDto): target is UserDatasetSchemaTargetDto {
    return target.type == SchemaType.UserDataset;
  }

  export function isResultSet(target: SchemaTargetDto | ResultSetSchemaTargetDto): target is ResultSetSchemaTargetDto {
    return target.type == SchemaType.ResultSet;
  }

  export function same(l: SchemaTargetDto, r: SchemaTargetDto) {
    if (l === r)
      return true;

    if (!l) {
      if (!r)
        return true;

      return false;
    }
    else if (!r)
      return false;

    if (isCore(l) && isCore(r)) {
      return l.product?.toLowerCase() == r.product?.toLowerCase() && 
             l.name?.toLowerCase() == r.name?.toLowerCase();
    }

    if (isUserDataset(l) && isUserDataset(r)) {
      return l.userDatasetId == r.userDatasetId;
    }

    if (isResultSet(l) && isResultSet(r)) {
      return l.resultSetId == r.resultSetId;
    }

    return false;
  }

  export function sameField(l: SchemaFieldTargetDto, r: SchemaFieldTargetDto) {
    if (l === r)
      return true;

    if (!l) {
      if (!r)
        return true;

      return false;
    }
    else if (!r)
      return false;

    if (l.childField?.toLowerCase() != r.childField?.toLowerCase() ||
        l.field?.toLowerCase() != r.field?.toLowerCase() || 
        l.group?.toLowerCase() != r.group?.toLowerCase()) {
      return false;
    }

    if (!same(l.schema, r.schema))
      return false;

    return true;
  }

  export function sameTargets(l: SchemaFieldTargetDto, r: SchemaFieldTargetDto, checkDisplayName = true) {
    if (!sameField(l, r))
      return false;

    if ((l.aggregation ?? DataAggregationFunction.DoNotSummarize) != (r.aggregation ?? DataAggregationFunction.DoNotSummarize)) {
      return false;
    }

    if (checkDisplayName) {
      if (l.displayName?.toLowerCase() != r.displayName?.toLowerCase())
        return false;
    }

    return true;
  }

  export function hasAggregation(target: SchemaFieldTargetDto) {
    return target.aggregation && target.aggregation != DataAggregationFunction.DoNotSummarize;
  }

  export function userDatasetTarget(userDataset: ListUserDatasetDto): UserDatasetSchemaTargetDto {
    return {
      type: SchemaType.UserDataset,
      name: userDataset.name,
      userDatasetId: userDataset.id
    };
  }

  export function getTargetString(target: SchemaTargetDto) {
    if (SchemaUtils.isCore(target)) {
      return `${target.product}/${target.name}`;
    }
    else if (SchemaUtils.isUserDataset(target)) {
      return `${target.userDatasetId}/${target.name}`;
    }
    else if (SchemaUtils.isResultSet(target)) {
      return `${target.resultSetId}/${target.name}`;
    }
  }

  export function getFieldTargetString(target: SchemaFieldTargetDto) {
    if (target.childField) {
      return `${target.group}/${target.field}/${target.childField}`;
    }
    else
      return `${target.group}/${target.field}`;
  }

  export function getTargetDisplayString(target: SchemaFieldTargetDto) {
    if (target.childField) {
      return `${target.group} - ${target.field} - ${target.childField}`;
    }
    else
      return `${target.group} - ${target.field}`;
  }
}
